export var SavedPaymentKpayEnum;
(function (SavedPaymentKpayEnum) {
    SavedPaymentKpayEnum["CARD"] = "card";
    SavedPaymentKpayEnum["CASH"] = "cash";
    SavedPaymentKpayEnum["TRANSFER"] = "transfer";
})(SavedPaymentKpayEnum || (SavedPaymentKpayEnum = {}));
